var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 358.398,
    viewBox: "0 0 512 358.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_275",
    "data-name": "Raggruppa 275",
    transform: "translate(0 -77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_774",
    "data-name": "Tracciato 774",
    d: "M501.3,132.96A64.119,64.119,0,0,0,456.035,87.7C416.107,77,256,77,256,77S95.893,77,55.965,87.7A64.122,64.122,0,0,0,10.7,132.96C0,172.893,0,256.2,0,256.2s0,83.308,10.7,123.236A64.114,64.114,0,0,0,55.965,424.7C95.893,435.4,256,435.4,256,435.4s160.109,0,200.037-10.7A64.112,64.112,0,0,0,501.3,379.433C512,339.505,512,256.2,512,256.2S512,172.893,501.3,132.96Z",
    fill: "red",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_775",
    "data-name": "Tracciato 775",
    d: "M204.8,333l133.014-76.8L204.8,179.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ec6fdea97751498acec6d618722044b7.svg";
export { ForwardRef as ReactComponent };